import { Post } from '@wellesley/openapi'

import isRepost from './isRepost'

const getIsNotAvailablePostContent = (
  feed: Post,
  isQuotePost = false,
  hidePrivatePosts = false,
) => {
  return (
    feed.muted ||
    feed.deleted ||
    feed.blocked ||
    feed.visible === false ||
    (hidePrivatePosts && isQuotePost && feed.privacy === 'PRIVATE') ||
    (hidePrivatePosts &&
      isRepost(feed) &&
      feed.originalPost?.privacy === 'PRIVATE')
  )
}

export default getIsNotAvailablePostContent
